const PermissionKeys = {
  Warehouse: {
    Inventory: {
      Write: "Warehouse:Inventory:Write",
    },
    PWAModule: "Warehouse:PWAModule",
  },
};

export default PermissionKeys;
